import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InnerHTML from 'dangerously-set-html-content'
import { isMobile } from 'react-device-detect';
import SubmitFormWrapper from './SubmitForm.style';
import postHighFives from './postHighFives';
import Button from '../../components/Button/Button';
import TextArea from '../../components/TextArea/TextArea';
import ItemSelector from '../../components/ItemSelector/ItemSelector';
import TypeAheadSearch from '../../components/TypeAheadSearch/TypeAheadSearch';
import { isFormComplete, validateRecipient } from '../../lib/validation.utils';
import { lookupUserByEmail } from '../../services/userLookup';
import { getTokenSubject } from '../../lib/auth.utils';
import { SwooshWrapper, AppTitle } from '../../components/AppBanner/AppBanner.style';
import pageCopy from "../../copy"
import { MaximButtonArray } from '../../components/MaximButtonArray/MaximButtonArray';

class SubmitForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        sender: props.user.name,
        // The API rejects the submission unless this matches the access token's
        // subject, so the token wins over the profile email when they disagree.
        senderEmail: getTokenSubject() || props.user.email,
        senderCompany: window.sessionStorage.company,
        recipientEmail: '',
        recipientEmailList: [],
        recipients: [],
        senderInfo: null,
        maximType: window.sessionStorage.company === 'converse' ? 'value' : 'maxim',
      },
      saveSuccess: false,
      saveLoading: false,
      saveError: false,
      emailError: false,
      userLimitError: false,
      isLoadingMaxim: false
    };
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleLoading = this.handleLoading.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitToConfirmationPage = this.handleSubmitToConfirmationPage.bind(this);
  }

  // The sender's own org/title/manager come from the same directory lookup as
  // the recipient's. Resolved once up front so submitting stays a single call,
  // and left null on failure so the API falls back to its own lookup.
  async componentDidMount() {
    const senderInfo = await lookupUserByEmail(this.state.form.senderEmail);
    if (senderInfo) {
      this.setState({
        form: {
          ...this.state.form,
          sender: this.state.form.sender || senderInfo.fullName,
          senderInfo
        }
      });
    }
  }

  handleNameChange(name, email, recipients) {
    const emailList = recipients.map(user => (user.email || '').toLowerCase());
    this.setState(
      {
        form: {
          ...this.state.form,
          recipientEmail: email,
          recipientEmailList: emailList,
          recipients,
          saveError: false,
          emailError: false,
          userLimitError: false
        }
      },
      () => {
        this.handleFormChange('recipient', name);
      }
    );
  }

  handleFormChange(id, text) {
    if (id === 'maximType') {
      this.setState({
        form: {
          ...this.state.form,
          maxim: null,
          senderCompany: text === 'value' ? 'converse' : 'nike',
          [id]: text,
        }
      });
    }
    else {
      this.setState({
        form: {
          ...this.state.form,
          [id]: text,
        }
      });
    }
  }

  handleLoading() {
    this.setState({ isLoadingMaxim: true });
    setTimeout(() => this.setState({ isLoadingMaxim: false }), 500);
  }

  handleSubmitToConfirmationPage = () => {
    this.props.onConfirmSubmit(this.state.saveSuccess);
  };

  handleSubmit(evt) {
    evt.preventDefault();
    this.setState(
      {
        saveLoading: true,
        saveSuccess: false,
        saveError: false,
        emailError: false,
        userLimitError: false
      },
      async () => {
        logger.log(this.state.form.recipientEmailList);
        logger.log(this.state.form.senderEmail);

        if (
          this.state.form.recipientEmailList.length > 10 ||
          !validateRecipient(this.state.form.senderEmail, this.state.form.recipientEmailList)
        ) {
          if (this.state.form.recipientEmailList.length > 10) {
            this.setState({
              saveLoading: false,
              userLimitError: true
            });
          }
          if (!validateRecipient(this.state.form.senderEmail, this.state.form.recipientEmailList)) {
            this.setState({
              saveLoading: false,
              emailError: true,
            });
          }
          return;
        }

        const senderInfo =
          this.state.form.senderInfo || (await lookupUserByEmail(this.state.form.senderEmail));

        const responses = await postHighFives({ ...this.state.form, senderInfo });
        logger.log(responses);
        const errors = responses.filter(res => res.error === true);
        if (errors.length === 0) {
          this.setState(
            {
              saveLoading: false,
              saveSuccess: true
            },
            () => {
              this.handleSubmitToConfirmationPage();
            }
          );
        } else {
          this.setState({
            saveLoading: false,
            saveError: true
          });
        }
      }
    );
  }

  render() {
    const { form, saveSuccess, saveError, saveLoading, emailError, userLimitError } = this.state;
    const { recipient, recipientEmail, maxim, message, senderEmail } = form;
    const isFormValid = isFormComplete(recipient, recipientEmail, maxim, message, senderEmail);
    const qualtricshtml = `<!--BEGIN QUALTRICS WEBSITE FEEDBACK SNIPPET-->
    <script type='text/javascript'>
    (function(){var g=function(e,h,f,g){
    this.get=function(a){for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){for(var d=c[b];" "==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};
    this.set=function(a,c){var b="",b=new Date;b.setTime(b.getTime()+6048E5);b="; expires="+b.toGMTString();document.cookie=a+"="+c+b+"; path=/; "};
    this.check=function(){var a=this.get(f);if(a)a=a.split(":");else if(100!=e)"v"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(":"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case "v":return!1;case "r":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(":")),!c}return!0};
    this.go=function(){if(this.check()){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)}};
    this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};
    try{(new g(100,"r","QSI_S_ZN_3Itxoisu1z0URCe","https://zn3itxoisu1z0urce-nikeemployeevoice.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_3Itxoisu1z0URCe")).start()}catch(i){}})();
    </script><div id='ZN_3Itxoisu1z0URCe'><!--DO NOT REMOVE-CONTENTS PLACED HERE--></div>
    <!--END WEBSITE FEEDBACK SNIPPET-->`

    if (isMobile) {
      return (
        <div
          style={{
            textAlign: 'center'
          }}
        >
          <div
            className="ncss-col-sm-12 mt5-sm ta-sm-c"
            style={{
              backgroundColor: '#ffffff',
              alignContent: 'center',
              height: '99.5%'
            }}
          >
            <SubmitFormWrapper>
              <div style={{ display: saveSuccess ? 'none' : 'block' }}>
                <SwooshWrapper>
                  <AppTitle>
                    <img
                      src={pageCopy[window.sessionStorage.company].highFiveLogo}
                      alt="High Five Logo"
                    />
                  </AppTitle>
                </SwooshWrapper>
                <div className="ncss-row">
                  <div className="ncss-col-sm-12">
                    <p style={{ color: '#757575' }} className="ncss-base fs14-sm fs16-md ta-sm-c mt1-sm mb12-sm">
                      {`Simply fill out the form below. The High Five recipient(s) and their manager
                      will receive an email with your comments.`}
                    </p>
                  </div>
                </div>
                <div className="ncss-row">
                  <div className="ncss-col-sm-12 ncss-textarea-container">
                    <h2
                      htmlFor="input"
                      className="ncss-brand ncss-label pr6-sm fs22-sm mb1-sm"
                      style={{ color: '#031B39' }}
                    >
                      I want to High Five:
                    </h2>
                    <div className="ncss-row">
                      <div className="ncss-col-sm-12">
                        <div className="ncss-form-group">
                          <div>
                            <TypeAheadSearch handleNameEmail={this.handleNameChange} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ncss-row mb4-sm">
                      <div className="ncss-col-sm-12 ncss-textarea-container text-color-grey">
                        Maximum Recipients: 10
                      </div>
                    </div>

                    <div className="ncss-row mb4-sm">
                      <div className="ncss-col-sm-12 ncss-textarea-container ">
                        {emailError && (
                          <div className="ncss-row">
                            <div className="ncss-col-sm-12 text-color-error ncss-base">
                              <span className="g72-x-thick mr1-sm" />
                              You can&apos;t High Five yourself
                            </div>
                          </div>
                        )}
                        {userLimitError && (
                          <div className="ncss-row">
                            <div className="ncss-col-sm-12 text-color-error ncss-base">
                              <span className="g72-x-thick mr1-sm" />
                              Only 10 recipients can be included per High Five
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="ncss-row mb6-sm">
                      <div className="ncss-col-sm-12">
                        <div className="ncss-form-group">
                          <div className="ncss-textarea-container">
                            <label
                              htmlFor="message"
                              className="ncss-brand ncss-label pr6-sm fs22-sm mb1-sm"
                              style={{ color: '#031B39' }}
                            >
                              For:
                            </label>
                            <TextArea
                              id="message"
                              placeholder="Provide detail here ..."
                              handleTextAreaInput={this.handleFormChange}
                            />
                            <div className="ncss-error-msg">Please enter details</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ncss-row mb7-sm">
                      <div className="ncss-col-sm-12">
                        <div className="ncss-select-container mb6-sm mb0-md">
                          <label
                            className="ncss-brand ncss-label pr6-sm fs22-sm mb1-sm u-full-width"
                            htmlFor="maxim"
                            style={{ color: '#031B39' }}
                          >
                            {`${
                              form.recipientEmailList.length > 1 ? 'They' : form.recipient || 'They'
                            } embodied the...`}
                            {/* <a
                              href={pageCopy[window.sessionStorage.company].valueHomepage}
                              target="blank"
                              className="maxim-link"
                            >
                              {pageCopy[window.sessionStorage.company].valueName}
                            </a>
                            : */}
                          </label>
                          <MaximButtonArray typeChooser={true} handleFormChange={this.handleFormChange} maximType={this.state.form.maximType} isLoading={this.state.isLoadingMaxim} handleLoading={this.handleLoading} />
                          {/* <ItemSelector
                            id="maxim"
                            placeholder="Select one"
                            items={pageCopy[window.sessionStorage.company].values}
                            selectItem={this.handleFormChange}
                          /> */}
                          <div className="ncss-error-msg">
                            Please select a {pageCopy[window.sessionStorage.company].valueName}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ncss-row mb7-sm">
                      <div className="ncss-col-sm-12">
                        <div className="ncss-select-container mb6-sm mb0-md">
                          <label className="ncss-col-sm-12 ncss-textarea-container text-color-grey">
                            {`Select ${this.state.form.maximType === 'maxim' ? 'Maxim' : 'Value'}`}
                          </label>
                          <MaximButtonArray handleFormChange={this.handleFormChange} maximType={this.state.form.maximType} maxim={this.state.form.maxim} isLoading={this.state.isLoadingMaxim} handleLoading={this.handleLoading} />
                        </div>
                      </div>
                    </div>

                    <div className="ncss-row mb6-sm">
                      <div className="ncss-col-sm-12">
                        <div className="ncss-select-container ta-sm-c ta-md-r" style={{ display: 'flex', justifyContent: 'center' }}>
                          <Button
                            text="Send High Five"
                            handleClick={this.handleSubmit}
                            background="#111"
                            color="#ffffff"
                            isLoading={saveLoading}
                            disabled={!isFormValid || saveLoading}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="ncss-row mb7-sm">
                      <div className="ncss-col-sm-12 ncss-col-md-6" />
                      <div className="ncss-col-sm-12 ncss-col-md-6">
                        {saveError && (
                          <div className="ncss-row">
                            <div className="ncss-col-sm-12 mt4-sm ta-sm-c ta-md-r text-color-error ncss-base">
                              <span className="g72-x-thick mr1-sm" /> Error submitting High Five.
                              Please try again.
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </SubmitFormWrapper>
          </div>
        </div>
        // <div
        //   className="ncss-col-sm-10"
        //   style={{
        //     backgroundColor: '#f5f5f5',
        //     width: '100%',
        //     height: '99%',
        //     right: '1%',
        //     textAlign: 'center'
        //   }}
        // >

        // </div>
      );
    }
    return (
      <div
        className="ncss-col-sm-10"
        style={{
          backgroundColor: '#f5f5f5',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          className="ncss-col-sm-6 mt5-sm ta-sm-c"
          style={{
            backgroundColor: '#ffffff',
            alignContent: 'center',
            width: '100%',
            margin: '50px 100px'
          }}
        >
          <InnerHTML html={qualtricshtml} />
          <SubmitFormWrapper>
            <div style={{ display: saveSuccess ? 'none' : 'block' }}>
              <SwooshWrapper>
                <AppTitle>
                  <img
                    src={pageCopy[window.sessionStorage.company].highFiveLogo}
                    alt="High Five Logo"
                  />
                </AppTitle>
              </SwooshWrapper>
              <div className="ncss-row">
                <div className="ncss-col-sm-12" style={{ display: 'flex', justifyContent: 'center' }}>
                  <p style={{ color: '#757575', width: '650px' }} className="ncss-base fs14-sm fs16-md ta-sm-c mt1-sm mb12-sm">
                    {`Simply fill out the form below. The High Five recipient(s) and their manager will
                    receive an email with your comments.`}
                  </p>
                </div>
              </div>
              <div className="ncss-row">
                <div className="ncss-col-sm-12 ncss-textarea-container">
                  <h2
                    htmlFor="input"
                    className="ncss-brand ncss-label pr6-sm fs22-sm mb1-sm"
                    style={{ color: '#031B39',
                    backgroundColor: '#ffffff' }}
                  >
                    I want to High Five:
                  </h2>
                  <div className="ncss-row">
                    <div className="ncss-col-sm-12">
                      <div className="ncss-form-group">
                        <div>
                          <TypeAheadSearch
                            id="namesearch"
                            handleNameEmail={this.handleNameChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="ncss-row mb4-sm">
                    <div className="ncss-col-sm-12 ncss-textarea-container text-color-grey">
                      Maximum Recipients: 10
                    </div>
                  </div>

                  <div className="ncss-row mb4-sm">
                    <div className="ncss-col-sm-12 ncss-textarea-container ">
                      {emailError && (
                        <div className="ncss-row">
                          <div className="ncss-col-sm-12 text-color-error ncss-base">
                            <span className="g72-x-thick mr1-sm" />
                            You can&apos;t High Five yourself
                          </div>
                        </div>
                      )}
                      {userLimitError && (
                        <div className="ncss-row">
                          <div className="ncss-col-sm-12 text-color-error ncss-base">
                            <span className="g72-x-thick mr1-sm" />
                            Only 10 recipients can be included per High Five
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="ncss-row mb6-sm">
                    <div className="ncss-col-sm-12">
                      <div className="ncss-form-group">
                        <div className="ncss-textarea-container">
                          <label
                            htmlFor="message"
                            className="ncss-brand ncss-label pr6-sm fs22-sm mb1-sm"
                            style={{ color: '#031B39' }}
                          >
                            For:
                          </label>
                          <TextArea
                            id="message"
                            placeholder="Provide detail here ..."
                            handleTextAreaInput={this.handleFormChange}
                          />
                          <div className="ncss-error-msg">Please enter details</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="ncss-row mb3-sm">
                    <div className="ncss-col-sm-12">
                      <div className="ncss-select-container mb6-sm mb0-md">
                        <label
                          className="ncss-brand ncss-label pr6-sm fs22-sm mb1-sm u-full-width"
                          htmlFor="maxim"
                          style={{ color: '#031B39' }}
                        >
                          {`${
                            form.recipientEmailList.length > 1 ? 'They' : form.recipient || 'They'
                          } embodied the...`}
                          {/* <a
                            href={pageCopy[window.sessionStorage.company].valueHomepage}
                            target="blank"
                            className="maxim-link"
                          >
                            {pageCopy[window.sessionStorage.company].valueName}
                          </a> */}
                        </label>
                        <MaximButtonArray typeChooser={true} handleFormChange={this.handleFormChange} maximType={this.state.form.maximType} isLoading={this.state.isLoadingMaxim} handleLoading={this.handleLoading} />
                        {/* <ItemSelector
                          id="maxim"
                          placeholder="Select one"
                          items={pageCopy[window.sessionStorage.company].values}
                          selectItem={this.handleFormChange}
                        /> */}
                        <div className="ncss-error-msg">
                          Please select a{pageCopy[window.sessionStorage.company].valueName}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="ncss-row mb7-sm">
                    <div className="ncss-col-sm-12">
                      <div className="ncss-select-container mb6-sm mb0-md">
                        <label className="ncss-col-sm-12 ncss-textarea-container text-color-grey">
                          {`Select ${this.state.form.maximType === 'maxim' ? 'Maxim' : 'Value'}`}
                        </label>
                        <MaximButtonArray handleFormChange={this.handleFormChange} maximType={this.state.form.maximType} maxim={this.state.form.maxim} isLoading={this.state.isLoadingMaxim} handleLoading={this.handleLoading} />
                      </div>
                    </div>
                  </div>

                  <div className="ncss-row mb6-sm">
                    <div className="ncss-col-sm-12">
                      <div className="ncss-select-container ta-sm-c ta-md-c">
                        <Button
                          text="Send High Five"
                          handleClick={this.handleSubmit}
                          background="#111"
                          color="#ffffff"
                          isLoading={saveLoading}
                          disabled={!isFormValid || saveLoading}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="ncss-row mb7-sm">
                    <div className="ncss-col-sm-12 ncss-col-md-6" />
                    <div className="ncss-col-sm-12 ncss-col-md-6">
                      {saveError && (
                        <div className="ncss-row">
                          <div className="ncss-col-sm-12 mt4-sm ta-sm-c ta-md-r text-color-error ncss-base">
                            <span className="g72-x-thick mr1-sm" /> Error submitting High Five.
                            Please try again.
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </SubmitFormWrapper>
        </div>
      </div>
    );
  }
}

SubmitForm.propTypes = {
  onConfirmSubmit: PropTypes.func,
  user: PropTypes.object
};

SubmitForm.defaultProps = {
  user: {}
};

export default SubmitForm;



// WEBPACK FOOTER //
// ./src/containers/SubmitForm/SubmitForm.js